import { persistReducer, persistStore } from "redux-persist"
import storage from "redux-persist/lib/storage"
import { combineReducers, configureStore, Reducer } from "@reduxjs/toolkit"
import productsReducer from "./product/productSlice"
import { ProductState } from "./product/types"
import userReducer, { IUserState } from "./user/userSlice"
import { getPersistConfig } from "redux-deep-persist"

export interface RootState {
  user: IUserState
  products: ProductState
}

const rootReducer: Reducer<RootState> = combineReducers({
  user: userReducer,
  products: productsReducer,
})

const persistConfig = getPersistConfig({
  key: "root",
  storage,
  blacklist: [
    "products.glasses.coverLeft",
    "products.glasses.coverRight",
    "products.glasses.coverFront",
  ],
  rootReducer,
})

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
})

export const persistor = persistStore(store)
export type AppDispatch = typeof store.dispatch
